import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { surface } from "./foundation";
export function Table({ className, ...props }: ComponentProps<"table">) {
  return (
    <div className="overflow-x-auto">
      <table {...props} data-slot="table" className={cn("cyra-table", className)} />
    </div>
  );
}
export const TableHeader = surface("thead", "table-header");
export const TableBody = surface("tbody", "table-body");
export const TableFooter = surface("tfoot", "table-footer");
export const TableRow = surface("tr", "table-row");
export const TableHead = surface("th", "table-head");
export const TableCell = surface("td", "table-cell");
export const TableCaption = surface("caption", "table-caption");
